var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var pcbFont = require("./pcbFont");

var TextTracer = function(fontdefinition, flipY) {
    var self = this;

    this.charTraces = {};

    // y is height of all letters
    var yMin = Number.POSITIVE_INFINITY;
    var yMax = Number.NEGATIVE_INFINITY;

    for (var ch in fontdefinition ) {

        //Bounding Box
        var xMin = Number.POSITIVE_INFINITY;
        var xMax = Number.NEGATIVE_INFINITY;

        for(var i = 0; i < fontdefinition[ch].length; i++){
            var trace = fontdefinition[ch][i];
            for(var j = 0; j < trace.length; j++){
                var point = trace[j];

                if (point[1]<yMin){
                    yMin = point[1];
                }

                if (point[1]>yMax){
                    yMax = point[1];
                }
            }
        }
    }

    for (var ch in fontdefinition ) {

         //Bounding Box (x for each char)
        var xMin = Number.POSITIVE_INFINITY;
        var xMax = Number.NEGATIVE_INFINITY;

        for(var i = 0; i < fontdefinition[ch].length; i++){
            var trace = fontdefinition[ch][i];
            for(var j = 0; j < trace.length; j++){
                var point = trace[j];
                if (point[0]<xMin){
                    xMin = point[0];
                }

                if (point[0]>xMax){
                    xMax = point[0];
                }
            }
        }

        // traces
        var traceSet = new lib_core.Collections.HashSet();
        traceSet.width = xMax-xMin;

        for (var i=0; i<fontdefinition[ch].length; i++){
            var trace = new lib_geometry.Trace(fontdefinition[ch][i]);
            if(flipY){
                trace = trace.scale(1, -1);
                trace = trace.translate(new lib_geometry.Coord(0, yMax));
                // translate down by total height of font
            }
            traceSet.add(trace);
        }

        // set width of character
        traceSet.width = xMax-xMin;

        this.charTraces[ch] = traceSet;
    }

    this.charTraces[" "].removeAll();

};

TextTracer.prototype.getCharTraces = function(ch) {
    var self = this;
    if (self.charTraces[ch]) {
        return self.charTraces[ch];
    } else {
        return self.charTraces['-'];
    }
};


TextTracer.prototype.text2traces = function(text, width, pos) {
    var self = this;
    var traces = new lib_core.Collections.HashSet();

    var total_width = 0;

    for(var i=0; i<text.length; i++) {
        var ch = text.charAt(i);
        var charTraceSet = self.getCharTraces(ch);
        total_width += width * charTraceSet.width / 9;
        if (i !== text.length-1) {
            total_width += width * 4 / 9;
        }
    }

    var total_height = 12*width/9;

    var currentPos = pos.add(new lib_geometry.Coord(-total_width/2,total_height/2));

    for(var i=0; i<text.length; i++) {
        var ch = text.charAt(i);
        var charTraceSet = self.getCharTraces(ch);

        traces.addAll(self.char2traces(ch, currentPos, width, 2*width/9));

        currentPos = currentPos.add(new lib_geometry.Coord(width * (charTraceSet.width+4) / 9,0));
    }



    return traces;
};

TextTracer.prototype.getBBox = function(text, width) {
    var self = this;

    var total_width = 0;

    for(var i=0; i<text.length; i++) {
        var ch = text.charAt(i);
        var charTraceSet = self.getCharTraces(ch);
        total_width += width * charTraceSet.width / 9;
        if (i !== text.length-1) {
            total_width += width * 4 / 9;
        }
    }
    var stroke = 2*width/9;

    total_width += stroke;
    var total_height = 12*width/9 + stroke;

    return new lib_geometry.BoundingBox(-total_width/2,-total_height/2, total_width, total_height);
};

TextTracer.prototype.char2traces = function(ch, pos, width, stroke) {
    var self = this;



    var result = new lib_core.Collections.HashSet();
    var traces = self.getCharTraces(ch);

//    if (traces === undefined) {
//        traces = self.charTraces['C'];
//    }

    if (traces !== undefined) {
        traces.forEach(function(trace){
            var newTrace = trace.scale(width/9,-width/9).translate(pos);
            newTrace.width = stroke;
//            newTrace.width = 10;
            result.add(newTrace);
        });
    }

    return result;
};

module.exports = new TextTracer(pcbFont, true);
